import { Link } from 'gatorcomponents';
import React from 'react';

export default {
  manualSelectDns: {
    backLabel: 'Volver',
    cancelLabel: 'Cancelar',
    continueLabel: 'Continuar',
    nextStepLabel: 'Próximo passo',
    finishLabel: 'Ok, entendí',
    howToSetupLabel: 'Ver cómo configurar',
    backToInstructions: 'Volver a las instrucciones',
    helpLink: (
      <>
        {'¿Tiene dificultades? '}
        <Link
          href="https://soporte.hostgator.mx/hc/es-419"
          target="_blank"
          text="Ingrese a la Central de ayuda"
        />
      </>
    ),
    titleV2: 'Cómo configurar el dominio en el otro proveedor de sitios',
    close: 'Cerrar',
    step: {
      disclaimerExternalDomain: {
        title: 'Su dominio no está registrado en HostGator. Para activar la CDN, es necesario ajustar el apuntamiento a Cloudflare',
        subtitle: ({ domain }) => `Siga las instrucciones de la siguiente pantalla para configurar correctamente el dominio "${domain}".`,
        cta: 'Iniciar configuración',
      },
      checkStatus: {
        title: 'Verificar Dominio',
        subtitle: 'Verifica el estado de configuración de tu dominio.',
        description: 'Estamos revisando si todo está listo para activar tu CDN...',
        whereDomainIsConfiguredLabel: '¿Dónde se registró el dominio?',
        selectHostPlaceholder: 'Seleccionar proveedor',
      },
      domainOriginalRegistration: {
        title: 'Verificar dominio',
        subtitle: 'Verifica el estado de configuración de tu dominio.',
        alertDescription: domain => (
          <>
            {'Como el dominio '}
            <span>
              {`"${domain}" `}
            </span>
            no se registró en HostGator, necesitas acceder al sitio donde se registró y cambiar las configuraciones para que apunten a tu hospedaje en HostGator.
          </>
        ),
        inputLabel: 'Selecciona dónde se registró',
        selectPlaceholder: 'Seleccionar',
      },
      domainOriginalRegistrationV2: {
        subtitle: 'Seleccione el proveedor donde se registró el dominio',
        selectPlaceholder: 'Seleccionar',
        disabledNextStepToolTip: 'Haga clic en el botón del proveedor para continuar',
      },
      howToSetup: {
        title: 'Cómo configurar dominio en otro proveedor de sitio',
        howToSectionTitle: 'Sigue los pasos para cambiar tu nombre de servidor',
        steps: ({ from }) => [
          {
            id: 'firstStep',
            description: 'Accede al sitio del proveedor donde se registró tu dominio',
          },
          {
            id: 'secondStep',
            description: `Localiza los nombres de servidores (DNS) actuales en el sitio de ${from}`,
          },
          {
            id: 'thirdStep',
            description: `Reemplaza los nombres de servidores (DNS) que están en el sitio de ${from} por los de CloudFlare. Solo copia y pega los valores a continuación:`,
            alert: 'Al continuar, tus configuraciones actuales del dominio serán cambiadas',
          },
        ],
        serverLabel: index => `Servidor ${index + 1} (DNS): `,
        goTo: selectedManualDns => `ir a ${selectedManualDns}`,
        alreadyMadeChanges: 'Continuar',
        backtoInstructions: 'Volver',
      },
      howToSetupV2: {
        subtitle: 'Reemplace los nombres de servidores actuales (DNS) con los nuevos nombres de servidores de abajo. Copie los valores, péguelos en el sitio web de su proveedor actual y guarde los cambios.',
        alert: 'Al continuar, sus configuraciones actuales de dominio se cambiará a las de Cloudflare',
        serverLabel: index => `Servidor ${index + 1}: `,
        alreadyMadeChanges: 'Ya hice la configuración',
        originalDnsLabel: 'Nombres de servidores actuales (DNS)',
        newDnsLabel: 'Su nuevo nombre de servidor (DNS)',
        configureDomainText: 'Al hacer clic en "configurar dominio", será redirigido al sitio de su proveedor para realizar el paso 2. Esta acción es necesaria para que su dominio pase a usar una CDN.',
        configureDomainButton: 'Configurar dominio',
        domainHasConfiguredLabel: 'Ya configuré mi dominio para Cloudflare.',
        backtoInstructions: 'Volver',
      },
      finishDomainSetup: {
        title: 'Finalizando las configuraciones de dominio',
        subtitle: 'Después de haber realizado las configuraciones, sigue aquí el estado de tu dominio.',
        box: {
          title: 'Cambios que realizaste:',
          description: ({ from }) => `DNS actual en ${from} por DNS de Hostgator`,
          alert: (
            <>
              <strong>
                {'En proceso: '}
              </strong>
              {'La configuración del dominio aún está sucediendo y puede tardar hasta '}
              <strong>24 horas.</strong>
            </>
          ),
        },
      },
      finishDomainSetupV2: {
        title: 'Finalizando las configuraciones de dominio',
        subtitle: 'Acompañe aquí el status de su dominio.',
        box: {
          title: 'Cambios que ha realizado:',
          description: ({ from }) => `Transferencia ${from && `de DNS${from}`} a DNS de Cloudflare.`,
          alert: (
            <>
              <strong>
                {'Em andamento: '}
              </strong>
              {'La configuración del dominio aún está en proceso y puede tardar hasta '}
              <strong>24 horas.</strong>
            </>
          ),
        },
      },
      domainNotRegistered: {
        title: domain => `El dominio “${domain}” aún no está registrado`,
        description: 'Para crear un nuevo sitio, el dominio necesita estar registrado y activo. Haz clic en el botón para registrarlo ahora mismo!',
        redirectLabel: 'Registrar dominio',
      },
      activationError: {
        domainWithProblemTitle: 'Dominio no disponible temporalmente',
        domainWithProblemDescription: 'No fue posible activar la CDN debido a problemas con su dominio, por favor, comuníquese con su registrante y confirme si hay algo pendiente.',
        confirmationCta: 'Ok, entendí',
      },
    },
  },
};
